module.exports = __webpack_public_path__ + "822c1a53be4ba6628c1dec5f62885cc4.png";


//////////////////
// WEBPACK FOOTER
// ./images/pics2/11.png
// module id = 295
// module chunks = 0